import React from "react";
import GitHubIcon from "@material-ui/icons/GitHub";

const Social = ({ link, target, Icon, text }) => {
  return (
    <div className="social">
      <a href={link} target={target} rel="noreferrer">
        <Icon fontSize="large" />
        <span className="ml-3">{text}</span>
      </a>
    </div>
  );
};

export default Social;
